module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_2.435e3794.png";